import { Styles } from "../../../../../../legacyComponents/config"

const styles = {
	checkbox: {
		width: "25px",
		height: "25px",
		minWidth: "25px",
		minHeight: "25px",
		fontSize: "unset",
		cursor: "pointer",
		outline: "unset",
		border: "1px solid #465578",
		borderRadius: "5px",
		transition: "all 0.2s ease"
	},
	checkboxLabel: {
		cursor: "pointer"
	},
	column: {
		display: 'flex',
		flexDirection: "column",
		justifyContent: 'space-between',
		alignItems: 'stretch',
		gap: '15px',
		marginTop: '18px !important'
	},
	numberInput: {
		'-moz-appearance': 'textfield',
		'-webkit-appearance': 'none',
		margin: 0,
	},
	outlinedInput: {
		width: "100%",
		'& .MuiOutlinedInput-input': {
			padding: "14px",
			fontSize: "14px",
			'-moz-appearance': 'textfield',
			'-webkit-appearance': 'none',
			margin: 0,
		},
		'& .MuiOutlinedInput-notchedOutline': {
			borderColor: "#ACBEE8"
		},
		'&:hover .MuiOutlinedInput-notchedOutline': {
			borderColor: "#ACBEE8"
		},
		'&.Mui-focused .MuiOutlinedInput-notchedOutline': {
			borderColor: "#ACBEE8"
		},
		'&.Mui-disabled .MuiOutlinedInput-notchedOutline': {
			borderColor: "#ACBEE8",
			backgroundColor: "#f3f4f6"
		},
		borderRadius: "8px"
	},
	link: {
		cursor:"pointer",
		marginTop: "40px",
		fontSize: { zero: "0.7rem", xs2: "1rem" },
		color: Styles.Color.primary,
		textDecoration: "none"
	}
}

export default styles
